<script>

import {defineComponent} from "vue";
import TicketStats from "@/components/Admin/AdminDashboard/ticketStats.vue";
import ShiftManagement from "@/components/Admin/AdminDashboard/shiftManagement.vue";
import moment from "moment-timezone";

export default defineComponent({
  components: {ShiftManagement, TicketStats},
  mounted() {
    this.updateDateTime();
    this.timer = setInterval(() => {
      this.updateDateTime();
      $(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })
    }, 1000);

  },
  data() {
    return {
      activeTab: 'ticket_handling',
      dateTime: null
    }
  },
  methods: {
    updateDateTime(){
      let now = new Date();
      const easternTime = now.toLocaleString('en-US', {
        timeZone: 'America/New_York',
      });
      let finalDate=moment(easternTime).format("HH:mm")
      this.dateTime=finalDate;
    }
  }
})
</script>

<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-md-12 col-lg-12">
          <div>
            <ticket-stats :dateTime="dateTime"/>
          </div>
<!--          <ul class="nav nav-pills-primary jobs nav-fill mb-10" role="tablist">-->
<!--            <li class="nav-item">-->
<!--              <a class="nav-link active" data-toggle="tab" href="#joblogs" role="tablist" @click="activeTab='ticket_handling'">Ticket Handling Efficiency</a>-->
<!--            </li>-->
<!--            <li class="nav-item">-->
<!--              <a class="nav-link" data-toggle="tab" href="#apilogs" role="tablist" @click="activeTab='employee_shifts'">Employee Shift Timings</a>-->
<!--            </li>-->
<!--          </ul>-->
        </div>
      </div>
<!--      <div class="tab-content tab-space tab-subcategories">-->
<!--        <div>-->
<!--          <ticket-stats :dateTime="dateTime"/>-->
<!--        </div>-->
<!--        <div class="tab-pane" id="apilogs" v-if="activeTab==='employee_shifts'">-->
<!--          <shift-management :dateTime="dateTime"/>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</template>

<style scoped>

</style>